import { render, staticRenderFns } from "./yearSpreading.vue?vue&type=template&id=04afe2b8&"
import script from "./yearSpreading.vue?vue&type=script&lang=js&"
export * from "./yearSpreading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports